import { User, MunchedImage, TimePreference } from '.';

export enum SchedulerCalendarEventTypeQuestionType {
  'text' = 'text',
  'textarea' = 'textarea',
  'phone' = 'phone',
  'checkbox' = 'checkbox',
  'radio' = 'radio',
}

export enum SchedulerCalendarEventTypeLocation {
  'in_person' = 'in_person',
  'phone' = 'phone',
  'google_meet' = 'google_meet',
  'microsoft_teams' = 'microsoft_teams',
  'zoom' = 'zoom',
}

export enum SchedulerCalendarEventTypeMode {
  'collective' = 'collective',
  'availability' = 'availability',
  'fair' = 'fair',
}

export interface SchedulerCalendarEventTypeQuestion {
  title: string;
  required: boolean;
  inputType: SchedulerCalendarEventTypeQuestionType;
  options?: string[];
  active: boolean;
  contactKey?: string | null;
}

interface SchedulerUserAvailability {
  id: string;
  endTime: number;
  isAvailable: boolean;
  note: string;
  startTime: number;
}

export interface SchedulerCalendarEventTypeHost {
  userId: number;
  user: User;
  isOwner: boolean;
  location: SchedulerCalendarEventTypeLocation;
  timePreferenceGroupId: string | null;
}

export interface SchedulerCalendarEventType {
  id: number;
  active: boolean;
  enabled: boolean;
  name: string;
  location: SchedulerCalendarEventTypeLocation;
  description: string;
  urlSlug: string;
  color: string;
  durationMinutes: number;
  questions: SchedulerCalendarEventTypeQuestion[];
  maxDaysInAdvance?: number | null;
  earliestDate?: Date | null | string;
  latestDate?: Date | null | string;
  preBufferMinutes: number;
  postBufferMinutes: number;
  timezone: string;
  availability: TimePreference[];
  userId?: number;
  hosts: SchedulerCalendarEventTypeHost[];
  nextUserId?: number | null;
  mode: SchedulerCalendarEventTypeMode;
  visibleOnPage: boolean;
  hubspotActivityType: string | null;
}

export interface SchedulerCalendarEventLocationInfo {
  name: string;
  phone?: string;
  timezone: string;
  teamsId?: string;
  teamsUrl?: string;
  zoomId?: number;
  zoomUrl?: string;
  zoomPassword?: string;
}
export interface SchedulerCalendarEventAdd {
  userId: number;
  eventTypeId: number;
  startTime: string;
  locationInfo: SchedulerCalendarEventLocationInfo;
  answers?: Record<string, string>;
  emailAddress: string;
  guestEmails: string[];
  visitorJourneyStepId?: number;
  chatMessageId?: string;
}

interface SchedulerCalendarEventAttendee {
  userId: number;
  isOwner: boolean;
}

export interface SchedulerCalendarEvent {
  id: number;
  userId: number;
  eventType: SchedulerCalendarEventType;
  locationInfo: SchedulerCalendarEventLocationInfo;
  answers: Record<string, string>;
  userAvailability: SchedulerUserAvailability;
  emailAddress: string;
  guestEmails: string[];
  active: boolean;
  attendees: SchedulerCalendarEventAttendee[];
  location: SchedulerCalendarEventTypeLocation;
}

export type SchedulerCalendarPublicEvent = { id: string } & SchedulerCalendarEvent;

interface SchedulerTestimonials {
  name: string;
  title: string;
  quote: string;
  logoImage?: MunchedImage | null;
  logoImageId?: string | null;
}

export interface SchedulerAgentMeetPage {
  id: number;
  urlSlug: string;
  facebookUrl: string;
  twitterUrl: string;
  linkedinUrl: string;
  orgName: string;
  orgLogo?: string | null;
  orgLogoBg?: string | null;
  testimonials: SchedulerTestimonials[];
  allowInstantMeetings: boolean;
  bannerImage?: MunchedImage | null;
  bannerImageId?: string | null;
  instantMeetingImage?: MunchedImage | null;
  instantMeetingImageId?: string | null;
  profileImage?: MunchedImage | null;
  profileImageId?: string | null;
}

export interface SchedulerPublicAgentMeetPage {
  id: number;
  urlSlug: string;
  fullUrl: string;
  facebookUrl: string;
  twitterUrl: string;
  linkedinUrl: string;
  orgName: string;
  orgLogo?: string | null;
  orgLogoBg?: string | null;
  testimonials: SchedulerTestimonials[];
  allowInstantMeetings: boolean;
  bannerImage: MunchedImage | null;
  instantMeetingImage: MunchedImage | null;
  eventTypes: SchedulerCalendarEventType[];
  agent: User & { isAvailable: boolean };
  defaultAvailability: TimePreference[];
  clientKey: string;
}
